import { render, staticRenderFns } from "./ExceptionStatistics.vue?vue&type=template&id=2a96f252&scoped=true"
import script from "./ExceptionStatistics.vue?vue&type=script&lang=js"
export * from "./ExceptionStatistics.vue?vue&type=script&lang=js"
import style0 from "./ExceptionStatistics.vue?vue&type=style&index=0&id=2a96f252&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a96f252",
  null
  
)

export default component.exports